/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconIkosaedr = createReactComponent("outline", "ikosaedr", "IconIkosaedr", [["path", { "d": "M21 8.007v7.986a2 2 0 0 1 -1.006 1.735l-7 4.007a2 2 0 0 1 -1.988 0l-7 -4.007a2 2 0 0 1 -1.006 -1.735v-7.986a2 2 0 0 1 1.006 -1.735l7 -4.007a2 2 0 0 1 1.988 0l7 4.007a2 2 0 0 1 1.006 1.735", "key": "svg-0" }], ["path", { "d": "M3.29 6.97l4.21 2.03", "key": "svg-1" }], ["path", { "d": "M20.71 6.97l-4.21 2.03", "key": "svg-2" }], ["path", { "d": "M20.7 17h-17.4", "key": "svg-3" }], ["path", { "d": "M11.76 2.03l-4.26 6.97l-4.3 7.84", "key": "svg-4" }], ["path", { "d": "M12.24 2.03q 2.797 4.44 4.26 6.97t 4.3 7.84", "key": "svg-5" }], ["path", { "d": "M12 17l-4.5 -8h9z", "key": "svg-6" }], ["path", { "d": "M12 17v5", "key": "svg-7" }]]);

export { IconIkosaedr as default };
//# sourceMappingURL=IconIkosaedr.mjs.map
